import { render, staticRenderFns } from "./JiraIntegration.vue?vue&type=template&id=995e76b0&"
import script from "./JiraIntegration.vue?vue&type=script&lang=js&"
export * from "./JiraIntegration.vue?vue&type=script&lang=js&"
import style0 from "./JiraIntegration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "JiraIntegration.vue"
export default component.exports